/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.message_modal_upgrade.init());

App.message_modal_upgrade = {

  init() {
    this.serious_overage_message = "Sending this message will upgrade your plan and bill you immediately.";

    $(document)
      .off('click', '.js-upgrade-and-send-link', App.message_modal_upgrade.submit_form)
      .on('click', '.js-upgrade-and-send-link', App.message_modal_upgrade.submit_form);
    $(document)
      .off('click', '.js-message-modal-cancel-upgrade', App.message_modal_upgrade.reset_upgrade)
      .on('click', '.js-message-modal-cancel-upgrade', App.message_modal_upgrade.reset_upgrade);
    return $(document)
      .off('click', '.js-reopen-mm', App.message_modal_upgrade.reopen_messaging_modal)
      .on('click', '.js-reopen-mm', App.message_modal_upgrade.reopen_messaging_modal);
  },

  // what happens here if a superadmin adds credits to an account,
  // but doesn't update the plan credits? Does this still work?
  //
  // Runs on every recipient change, for the one modal being edited. Disables
  // Send when this message would go further over the plan than the overage
  // limit allows, and re-enables it once it no longer would.
  handle_serious_overage(pending_credits_used, $modal) {
    const overage_limit = $modal.find('.modal-state').attr('data-overage-limit');
    const $warning = $modal.find('.js-message-modal-postscript-warning');
    if ($warning.data('original-text') == null) { $warning.data('original-text', $warning.text()); }

    const srsly = (pending_credits_used < 0) && overage_limit &&
            (Math.abs(pending_credits_used) > overage_limit);
    const ps_warning = srsly ? App.message_modal_upgrade.serious_overage_message : $warning.data('original-text');

    $warning
      .text(ps_warning)
      .toggleClass('immediate-upgrade-warning', !!srsly);

    // Only undo a disable this check made, so an upload in progress stays blocked
    const $submit = $modal.find('.js-message-modal-submit');
    if (srsly) {
      $submit.prop('disabled', true).addClass('disabled');
    } else if ($submit.hasClass('disabled')) {
      $submit.prop('disabled', false).removeClass('disabled');
    }
    $modal.find('.js-upgrade-link').toggle(!srsly);
    return $modal.find('.js-upgrade-and-send-link').toggle(!!srsly);
  },

  reopen_messaging_modal(evt) {
    App.message_modal_upgrade.reset_upgrade();

    const modal_id = $(evt.target).closest(".modal-state").attr("id");
    return App.modals.show_modal(modal_id);
  },

  reset_upgrade(evt) {
    const modal_id = $(evt.target).closest(".modal-state").attr("id");

    // reset title for replies!
    const text = $(modal_id).hasClass('js-reply-modal') ?
             'Reply to ' + $('.msg-single .name').text()
           :
             "Send a New Message";
    $('.js-message-modal-title').text(text);
    $('.js-message-modal-upgrade-container').remove();
    return $('.js-slideupable').show();
  },

  submit_form() {
    return $(this).closest('.message-modal').find('.js-message-modal-submit').prop('disabled', false).click();
  }
};
